/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { TriggerReprocessRunActionsMutationResponse, TriggerReprocessRunActionsPathParams, TriggerReprocessRunActions400, TriggerReprocessRunActions404 } from "../models/TriggerReprocessRunActions";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { triggerReprocessRunActions } from "../axios/triggerReprocessRunActions";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const triggerReprocessRunActionsMutationKey = () => ["audit-reports-api", { url: '/aod-runs/:id/reprocess' }] as const

export type TriggerReprocessRunActionsMutationKey = ReturnType<typeof triggerReprocessRunActionsMutationKey>

export function triggerReprocessRunActionsMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = triggerReprocessRunActionsMutationKey()
        return mutationOptions<TriggerReprocessRunActionsMutationResponse, ResponseErrorConfig<TriggerReprocessRunActions400 | TriggerReprocessRunActions404>, {id: TriggerReprocessRunActionsPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return triggerReprocessRunActions(id, config)
          },
        })

}

/**
 * @description Triggers a reprocess of the order associated with a run using the Olaf API
 * @summary Trigger Olaf reprocess for a run
 * {@link /aod-runs/:id/reprocess}
 */
export function useTriggerReprocessRunActions<TContext>(options: 
{
  mutation?: UseMutationOptions<TriggerReprocessRunActionsMutationResponse, ResponseErrorConfig<TriggerReprocessRunActions400 | TriggerReprocessRunActions404>, {id: TriggerReprocessRunActionsPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? triggerReprocessRunActionsMutationKey()

          const baseOptions = triggerReprocessRunActionsMutationOptions(config) as UseMutationOptions<TriggerReprocessRunActionsMutationResponse, ResponseErrorConfig<TriggerReprocessRunActions400 | TriggerReprocessRunActions404>, {id: TriggerReprocessRunActionsPathParams["id"]}, TContext>
          

          return useMutation<TriggerReprocessRunActionsMutationResponse, ResponseErrorConfig<TriggerReprocessRunActions400 | TriggerReprocessRunActions404>, {id: TriggerReprocessRunActionsPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<TriggerReprocessRunActionsMutationResponse, ResponseErrorConfig<TriggerReprocessRunActions400 | TriggerReprocessRunActions404>, {id: TriggerReprocessRunActionsPathParams["id"]}, TContext>
      
}